module.exports = __webpack_public_path__ + "f229a244ff770f0a82ed657badcc13fb.png";